<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col sm="1" class="text-center text-sm-left mb-2 mb-sm-0">
       <a  @click="go_back" data-toggle="tooltip" data-placement="middle" title="Go Back" ><i class="material-icons" style="font-size:2.5em;color:#aaa;">arrow_back</i></a>
      </d-col>
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Form ></span>
        <h3 class="page-title">Gereja</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <frm-church />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import ChurchInfo from '@/components/church/ChurchForm.vue';

export default {
  name: 'church-form',
  components: {
    frmChurch: ChurchInfo,
  },
  methods:{
    go_back(){
      this.$router.push({name:'church-list'});
    }
  }
};
</script>

